<template>
  <div>
    <div
      class="modal fade"
      data-keyboard="false"
      data-backdrop="static"
      id="billsModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header" style="height: 60px">
            <div style="margin-left: 35%"></div>
            <h5 class="card-title text-center text-join">Download Boleto</h5>

            <button
              type="button"
              class="close"
              id="closeDownloadModal"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="class-desktop">
              <div class="table-wrapper-scroll-y my-custom-scrollbar">
                <table class="table table-md table-striped">
                  <thead>
                    <tr style="font-size: 12px">
                      <th>Documento</th>
                      <th>Nosso número</th>
                      <th>Vencimento</th>
                      <th>Valor</th>
                      <th style="z-index: 1">Agendar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="bill in downloadBills"
                      :key="'downloadGrid_' + bill.cod_id"
                      style="text-align: center"
                    >
                      <td class="align-middle">{{ bill.cod_num_docto }}</td>
                      <td class="align-middle">{{ bill.cod_nosso_numero }}</td>
                      <td class="align-middle">
                        {{ date_due_props[bill.cod_id] | formatDate }}
                      </td>
                      <td class="align-middle">
                        {{ bill.cod_vl_docto | formatCurrency }}
                      </td>
                      <td class="align-middle">
                        <div v-if="bill.nova_data_vencto">
                 
                          <b-form-datepicker
                            :date-disabled-fn="dateDisabled"
                            id="datepicker-full-width"
                            class="form-control input-date"
                            locale="pt"
                            size="sm"
                            :max="maxFunction(bill.nova_data_vencto)"
                            :min="bill.cod_dt_vencto"
                            v-model="changeDateBill[bill.cod_id]"
                          ></b-form-datepicker>

                          <!-- <input
                            id="initalDateBillDownload"
                            type="date"
                            class="form-control input-date"
                            :max="maxFunction(bill.nova_data_vencto)"
                            :min="bill.cod_dt_vencto"
                            v-model="changeDateBill[bill.cod_id]"
                            required
                          /> -->
                        </div>
                        <div v-else>{{ bill.cod_dt_vencto | formatDate }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="access-center">
                <button
                  class="btn access"
                  id="downloadBillGrid"
                  @click="downloadBill"
                  v-bind:disabled="processing"
                >
                  Download
                </button>
              </div>
            </div>

            <!-- MOBILE SCREEN-->

            <div class="row justify-content-center class-mobile">
              <div class="col-md-8">
                <div
                  v-for="bill in downloadBills"
                  :key="'downloadGrid' + bill.cod_id"
                  class="principal-div"
                >
                  <div class="col col-divs">
                    <div style="width: 45%">
                      <label>Documento</label><br />

                      {{ bill.cod_num_docto }}
                    </div>
                    <div style="width: 45%">
                      <label>Vencimento</label><br />
                      {{ date_due_props[bill.cod_id] | formatDate }}
                    </div>

                    <button
                      style="width: 10%; background-color: #fff"
                      id="collapseBillsDownload"
                      class="btn accordion-toggle"
                      data-toggle="collapse"
                      :data-target="'#' + bill.cod_id"
                    >
                      <em class="fa fa-chevron-down icons icon-chevron"></em>
                    </button>
                  </div>

                  <div class="hiddenRow column">
                    <div class="accordian-body collapse" :id="bill.cod_id">
                      <div class="col col-divs">
                        <div style="width: 45%">
                          <label>Nosso número</label><br />
                          {{ bill.cod_nosso_numero }}
                        </div>
                        <div style="width: 45%">
                          <label>Valor</label><br />
                          {{ bill.cod_vl_docto | formatCurrency }}
                        </div>
                      </div>
                      <div class="col col-divs">
                        <div style="width: 100%">
                          <label>Agendar</label><br />
                          <div
                            v-if="bill.nova_data_vencto"
                            style="
                              margin-bottom: 15px;
                              margin-top: 10px;
                              width: 50%;
                            "
                          >
                            <b-form-datepicker
                              :date-disabled-fn="dateDisabled"
                              id="datepicker-full-width"
                              class="form-control input-date"
                              locale="pt"
                              size="sm"
                              :max="maxFunction(bill.nova_data_vencto)"
                              :min="bill.cod_dt_vencto"
                              v-model="changeDateBill[bill.cod_id]"
                            ></b-form-datepicker>
                            <!-- 
                            <input
                              id="newDateBillDownload"
                              type="date"
                              class="form-control input-date"
                              :max="maxFunction(bill.nova_data_vencto)"
                              :min="bill.cod_dt_vencto"
                              v-model="changeDateBill[bill.cod_id]"
                              required
                            /> -->
                          </div>
                          <div v-else>
                            {{ bill.cod_dt_vencto | formatDate }}
                          </div>
                        </div>
                      </div>
                      <div class="access-center" style="margin-bottom: 10px">
                        <button
                          class="btn access"
                          id="downloadBillGridModal"
                          @click="downloadBill"
                          v-bind:disabled="processing"
                        >
                          Download
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import NavBar from "../../../../common/components/NavBar";
import FooterNav from "../../../../common/components/FooterNav";
import axios from "axios";
import router from "../../../../router/router";
import moment from "moment";

export default {
  components: { NavBar, FooterNav },
  name: "BillsDownloadGrid",
  data() {
    return {
      downloadBills: [],
      billsId: [],
      changeDateBill: {},
      date_due_props: {},
      processing: false,
      value: "",
    };
  },

  props: ["bills", "order_by"],

  mounted() {
    this.billsId = this.bills.map((key) => {
      return key["cod_id"];
    });

    for (let index in this.bills) {
      this.date_due_props[this.bills[index]["cod_id"]] =
        this.bills[index]["cod_dt_vencto"];
    }

    axios
      .get(`${process.env.API_PBM}/boletos/confirmationDueDate`, {
        params: { boleto_id: this.billsId, order_by: this.order_by },
      })
      .then((response) => {
        $("#billsModal").modal("show");
        this.downloadBills = response.data.data.boletos;
        for (let index in this.downloadBills) {
          if (this.downloadBills[index].nova_data_vencto) {
            let billId = this.downloadBills[index].cod_id;
            this.changeDateBill[billId] =
              this.downloadBills[index].cod_dt_vencto;
          }
        }
      })
      .catch((error) => {
        Vue.$toast.error("Ops! Boleto não disponível para download.", {
          position: "top-right",
          duration: 5000,
        });
      });
  },
  methods: {
    maxFunction(data) {
      return moment().add(data, "day").format("YYYY-MM-DD");
    },

    downloadBill: function () {
      this.processing = true;

      Vue.$toast.warning("Aguarde... Estamos preparando seu boleto.", {
        position: "top-right",
        duration: 5000,
      });

      let params = "";
      this.billsId.forEach(function (key, value) {
        params += `&boleto_id[]=${key}`;
      });

      Object.entries(this.changeDateBill).forEach(function (key) {
        params += `&nova_data_vencimento[${key[0]}]=${key[1]}`;
      });

      axios
        .get(`${process.env.API_PBM}/boletos/download?${params}`, {
          responseType: "blob",
        })

        .then((response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));

          let fileLink = document.createElement("a");

          fileLink.href = fileURL;

          fileLink.setAttribute(
            "download",
            `boleto_${new Date().toLocaleString()}.pdf`
          );

          document.body.appendChild(fileLink);

          fileLink.click();
          this.processing = false;

          $("#billsModal").modal("hide");
        })
        .catch(() => {
          this.processing = false;
          Vue.$toast.error("Ops! Não foi possível completar a ação.", {
            position: "top-right",
            duration: 5000,
          });
        });
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay();
      const day = date.getDate();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6 || day === 13;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";

.access {
  color: #fff;
  width: 20%;
  margin-top: -25px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 15px;
  margin-bottom: -20px;
}

.input-date {
  font-size: 12px;
  border: 1px solid #dfdfdf;
  width: 100%;
  text-align: center;
  cursor: pointer;
  background-color: transparent;
  margin-top: -10px;
  margin-bottom: -10px;
}

.text-join {
  color: rgb(100, 95, 95);
  font-size: 18px;
  margin-top: 5px;
  margin-bottom: -5px;
}
.table-sm td,
.table-sm th {
  padding: 0px;
  padding-left: 10px;
}
table thead th {
  background-color: #cacaca;
  color: #424242;
  font-size: 14px;
  text-align: center;

  position: sticky;
  top: 0;
}

.my-custom-scrollbar {
  position: relative;
  height: 350px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
.table {
  position: relative;
}
table tr {
  white-space: nowrap;
}
tbody {
  font-size: 12px;
  color: rgb(100, 95, 95);
}

.access-center {
  text-align: center;
  margin-top: 20px;
}

@media only screen and (max-width: 900px) {
  .text-join {
    margin-left: -5px;
  }

  .class-mobile {
    display: flex !important;
    width: 100%;
    margin: 0 auto;
  }
  .class-desktop {
    display: none !important;
  }

  .col-md-8 {
    background: #ebe7e7;
    padding: 3%;
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .buttons-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
  }

  .access {
    color: #fff;
    border-radius: 6px;
    width: 45%;
    height: 70%;
    font-size: 11px;
    cursor: pointer;
    padding: 5px;
    font-size: 12px;
    text-align: center;
  }

  .btn-filter {
    color: #424242;
    background-color: #fff;
    border: 1px solid #ebe7e7;
    font-size: 14px;
    line-height: 1;
    width: 35%;
    cursor: pointer;
  }
  .btn-filter:hover {
    color: #fff !important;
    background-color: #9c9a9a;
    border: 1px solid #ebe7e7;
  }
  .btn-checked {
    color: #fff;
    background-color: #9c9a9a;
    border: 1px solid #ebe7e7;
  }

  .hiddenRow {
    padding: 0 !important;
  }

  label {
    display: inline-block;
    font-size: 13px;
    color: #424242;
  }

  .icons {
    font-size: 20px;
    cursor: pointer;
  }

  .col-divs {
    display: inline-flex;
    margin: 0 auto;
    font-size: 11px;
  }

  .principal-div {
    margin-top: 20px;
    background-color: #fff;
    border-radius: 6px;
    padding: 5px;
    color: rgb(100, 95, 95);
  }
  .access-filter {
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    padding: 5px;
    font-size: 15px;
    height: 33px;
    width: 20%;
  }
  .access-mobile {
    color: #fff;
    border-radius: 6px;
    width: 100%;
    height: 70%;
    font-size: 11px;
    cursor: pointer;
    padding: 5px;
    font-size: 12px;
    text-align: center;
  }

  .form-group input,
  textarea {
    background-color: #fff;
    margin-bottom: 10px;
    margin-top: 3px;
    line-height: 1rem;
    font-size: 15px;
    margin-left: 0px;
    width: 100%;
  }
}

.class-mobile {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/components/home/bill/BillsDownloadModal.vue